import { useState } from 'react';
import AuthService from './services/auth.service';

const style = { 
    login_wrapper: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '50vh'
    }
}

export default function Login(props) {
  let APP_URL = window.location.hostname;
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

    if (APP_URL.includes('www.'))
        APP_URL = APP_URL.slice(4, undefined);
  
    const submitLogin = (e) => {
      e.preventDefault();
      setError("");
      setLoading(true);

      AuthService.login(email, password).then(
        () => {
          props.loginCallback();
        },
        (error) => {
          const resMessage =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();

          setLoading(false);
          setError(resMessage);
        }
      );
    }

  return(
    <div style={style.login_wrapper}>
      <h1>Please Log In</h1>
      <form autoComplete="on" action="#" onSubmit={submitLogin}>
        <label>
          <p>Email</p>
          <input type="text" value={email} onChange={(e) => setEmail(e.target.value)}/>
        </label>
        <label>
          <p>Password</p>
          <input type="password" value={password} onChange={(e) => setPassword(e.target.value)}/>
        </label>
        <div style={{marginTop: 16}}>
          <button type="submit">
              Submit
          </button>
        </div>
        <div style={{color: 'red', marginTop: 8}}>
            {loading ? "Loading..." : ''} {error}
        </div>
      </form>
    </div>
  )
}